import React, { useState, useEffect } from 'react';
import { List, ListItem, ListItemText, Typography, CircularProgress, Alert, Link } from '@mui/material';

function NewsFeed({ query }) {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!query) return;

    const fetchNews = async () => {
      setLoading(true);
      setError(null);

      // Point to your custom server endpoint which fetches from Google RSS
      const url = `https://api.christmas.termplanner.com.au/api/news?q=${encodeURIComponent(query)}`;

      try {
        const response = await fetch(url);
        const data = await response.json();
        
        if (data.status === 'error') throw new Error(data.message);
        
        // Take only the top 5 articles
        setArticles(data.articles.slice(0, 5));
      } catch (err) {
        setError("Could not fetch news. " + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, [query]);

  if (loading) return <CircularProgress />;
  if (error) return <Alert severity="warning">News currently unavailable.</Alert>;
  if (articles.length === 0) return <Typography>No recent news found for "{query}".</Typography>;

  return (
    <List>
      {articles.map((article, index) => (
        <ListItem key={index} divider alignItems="flex-start">
          <ListItemText
            primary={
              <Link href={article.link} target="_blank" rel="noopener noreferrer" underline="hover">
                {article.title}
              </Link>
            }
            secondary={
              <>
                <Typography component="span" variant="body2" color="text.primary">
                  {new Date(article.pubDate).toLocaleDateString()} — {article.source}
                </Typography>
              </>
            }
          />
        </ListItem>
      ))}
    </List>
  );
}

export default NewsFeed;